<template>
    <div v-if="content.blockstyle == 'logos'" class="logosbar">
        
        <div class="">
            <div class="blocksettings" v-if="!readonly" >
                <span>
                    <button class="btn btn-primary" @click.prevent="showModal = true" ><span class="material-icons ico">cancel</span></button>
                </span>
            </div>
            <logos :readonly="readonly" :pageid="content._id" :websiteid="websiteid"/>
        </div>

        <modal v-if="showModal" @close="showModal = false" title="Delete block">
            <form @submit.prevent="removePage(content._id)">
                <p>Weet je zeker dat je deze block wil verwijderen?</p>
                <button class="button" type="submit">Ja, ik weet het zeker</button>
            </form>
        </modal>
    </div>
    <div v-else-if="content.blockstyle == 'quote'" :style="'background-image: url('+content.blockimage+')'" :class="{'block-img': content.blockimage != null}">
        <div class="section-block quote" :class="content.blockalign + ' ' + content.blockheight">
            <div class="blocksettings" v-if="!readonly" >
                <span>
                    <button class="btn btn-primary" @click.prevent="showModal = true" ><span class="material-icons ico">cancel</span></button>
                </span>
            </div>
            <div class="container">
                <blockquote class="brooks">
                    <span v-if="readonly" v-html="content.pagetext">
                    </span>
                    <inline-editor v-if="!readonly" :editable="content.pagetext" :pageid="content._id" dbentry="pagetext" element="textarea"/>
                </blockquote>
            </div>
        </div>

        <modal v-if="showModal" @close="showModal = false" title="Delete block">
            <form @submit.prevent="removePage(content._id)">
                <p>Weet je zeker dat je deze block wil verwijderen?</p>
                <button class="button" type="submit">Ja, ik weet het zeker</button>
            </form>
        </modal>
    </div>
    <div v-else :style="[content.blockimagestyle == 'imgbg' ? {'background-image': 'url(' + content.blockimage + ')'} : {}]" :class="{'block-img': content.blockimage != null && content.blockimagestyle == 'imgbg'}">
        <div class="section-block" :class="content.blockalign + ' ' + content.blockheight">
            <div class="blocksettings" v-if="!readonly" >
                <span v-if="!cantdelete">
                    <button class="btn btn-primary" @click.prevent="showModal = true" ><span class="ico material-icons">cancel</span></button>
                </span>
            </div>
            <div class="container">
                <img v-if="content.blockimagestyle == 'imgright'" :src="content.blockimage" alt="image" class="block-feature block-feature-margin shadowed" style="--block-float: right; --block-width: 40%;"/>
                <h2 class="display-5 mb-4" v-if="readonly == false || content.pagetitle != ''">
                    <span v-if="readonly" class="edited_content">
                        {{ content.pagetitle }} 
                    </span>
                    <inline-editor v-if="!readonly" :editable="content.pagetitle" :pageid="content._id" dbentry="pagetitle" element="normal"/>
                </h2>
                <p :class="{'display-6 text-muted mw-750px': content.blockfontsize == 'large', 'display-7': content.blockfontsize == 'small'}"  v-if="readonly == false || content.pagetext != ''">
                    <span v-if="readonly" v-html="content.pagetext">
                    </span>
                    <inline-editor v-if="!readonly" :editable="content.pagetext" :pageid="content._id" dbentry="pagetext" element="textarea"/>
                </p>

                <button v-if="!readonly" class="image-icon-button mt-4" @click.prevent="imageModal = true, getimages(), setblockimagestyle()" ><span class="ico material-icons">photo_camera</span> Achtergrondafbeelding</button>

                <reviews :readonly="readonly" v-if="content.blockstyle == 'reviews'" :pageid="content._id" :websiteid="websiteid"/>

                <columns :readonly="readonly" v-if="content.blockstyle == 'columns'" :pageid="content._id" :websiteid="websiteid"/>

                <img v-if="content.blockimagestyle == 'imgunder'" :src="content.blockimage"  alt="image" class="mw-100 mt-5 shadowed"/>
            </div>

            <magazine-cards :readonly="readonly" v-if="content.blockstyle == 'cards'" :pageid="content._id" :websiteid="websiteid"/>

            <blog :readonly="readonly" v-if="content.blockstyle == 'blog'" :pageid="content._id" :websiteid="websiteid"/>

            <modal v-if="showModal" @close="showModal = false" title="Delete block">
                <form @submit.prevent="removePage(content._id)">
                    <p>Weet je zeker dat je deze block wil verwijderen?</p>
                    <button class="button" type="submit">Ja, ik weet het zeker</button>
                </form>
            </modal>

            <modal v-if="imageModal" @close="imageModal = false" title="Add image">
                <ul class="imageselector">
                    <li>
                        <upload-modal @clicked="getimages()" :websiteid="websiteid" thestyle="imageuploadbutton btn btn-primary"><span class="material-icons ico">add_circle</span> Upload</upload-modal>
                    </li>
                    <li v-for="image in images">
                        <button class="imagethumb" @click.prevent="setblockimage(image.image)" :style="'background-image: url('+ imageroot + image.image.split('uploads/').pop() +')'">
                            <span>{{ image.image }}</span>
                        </button>
                    </li>
                </ul>
                <form v-if="!readonly" id="blockimage" @submit.prevent="changeBlockSetting('blockimage', content.blockimage), changeBlockSetting('blockimagestyle', blockimagestyle)">
                    <input hidden placeholder="Voer afbeelding in" class="textinput form-control mr-2" type="text" name="field_blockimage" v-model="content.blockimage">
                    <div class="flex-row">
                        <select v-model="blockimagestyle" class="form-control mr-2">
                            <option value="imgbg" >Afbeelding als achtergrond</option>
                            <option value="imgunder" >Afbeelding onder tekst</option>
                            <option value="imgfull" >Afbeelding over volledige breedte</option>
                            <option value="imgright" >Afbeelding uitgelijnd rechts</option>
                            <option value="imgempty" >Geen achtergrondafbeelding</option>
                        </select>
                        <button type="submit" class="btn btn-primary">Opslaan</button>
                    </div>
                </form>
            </modal>
        </div>
            
        <img v-if="content.blockimagestyle == 'imgfull'" :src="content.blockimage" alt="image" class="w-100"/>
    </div>
</template>

<script>
import InlineEditor from '../app/InlineEditor.vue';
import Modal from '../modal/Modal.vue';
import UploadModal from '../modal/UploadModal.vue';
import MagazineCards from '../content/MagazineCards.vue';
import Blog from '../content/Blog.vue';
import Reviews from '../content/Reviews.vue';
import Columns from '../content/Columns.vue';
import Logos from '../content/Logos.vue';

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';
import { request } from 'http';

export default {
    components:{
        InlineEditor,
        MagazineCards,
        Reviews,
        Columns,
        Logos,
        Modal,
        Blog,
        UploadModal
    },
    props: {
        content: Object,
        cantdelete: Boolean,
        websiteid: String,
        readonly: Boolean
    },
    data: function() {
        return{
            showModal: false,
            imageModal: false,
            file: '',
            images: [],
            imageroot: process.env.VUE_APP_ROOT_API + '/',
            blockimagestyle: this.content.blockimagestyle
        }
    },
    methods: {
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        setblockimage(image){
            this.content.blockimage = this.imageroot+image.split("uploads/").pop()
        },
        setblockimagestyle(){
            if(this.content.blockimage == null || this.content.blockimagestyle == 'imgempty'){
                this.blockimagestyle = 'imgbg'
            }
        },
        getimages(){

            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
            .then(response => {
                this.images = response.data.response
            })
        },
        changeBlockSetting(thedbentry, thecontent){

            const requestOptions = {
              headers: authHeader()
            }

            const data = {
                websiteid: this.websiteid,
                pageid: this.content._id,
                dbentry: thedbentry,
                content: thecontent
            }

            axios.patch(process.env.VUE_APP_ROOT_API+'/pages/', data, requestOptions)
            .then(response => {
                if(thedbentry == 'blockalign'){
                    this.content.blockalign = thecontent
                } 
                if (thedbentry == 'blockheight') {
                    this.content.blockheight = thecontent
                }
                if (thedbentry == 'blockfontsize') {
                    this.content.blockfontsize = thecontent
                }
                if (thedbentry == 'blockimage') {
                    this.$emit('clicked')
                    this.imageModal = false
                }
            })
        },
        removePage(id){

            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id, requestOptions)
            .then(response => {
                this.showModal = false
                this.$emit('clicked')
            })
        }
    }
}
</script>